import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import MapActionTypes from './types';
import {
  getAddressCandidateSuccess,
  getAddressCandidateFailure,
  getAddressSuggestSuccess,
  getAddressSuggestFailure,
  getLotNumSuggestSuccess,
  getLotNumSuggestFailure
} from './actions';
import {
  getAddressSuggest,
  getAddressCandidate,
  getLotNumSuggest
} from 'services/map.service';

function* handleGetAddressSuggestion(request: any) {
  try {
    const response: AxiosResponse = yield call(
      getAddressSuggest,
      request.payload.text,
      request.payload.category,
      request.payload.limit,
      request.payload.location
    );

    if (response?.data?.suggestions) {
      yield put(getAddressSuggestSuccess(response.data.suggestions));
    } else {
      yield put(getAddressSuggestFailure('Unable to get address suggestion.'));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err)
      ? err.response?.data.message
      : undefined;
    put(getAddressSuggestFailure(msg || 'Unable to get address suggestion.'));
  }
}

function* handleGetAddressCandidate(request: any) {
  try {
    const response: AxiosResponse = yield call(
      getAddressCandidate,
      request.payload.text,
      request.payload.outFields,
      request.payload.magicKey
    );

    if (response?.data?.candidates) {
      yield put(getAddressCandidateSuccess(response.data.candidates));
    } else {
      yield put(
        getAddressCandidateFailure('Unable to get address candidates.')
      );
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err)
      ? err.response?.data.message
      : undefined;
    put(getAddressCandidateFailure(msg || 'Unable to get address candidates.'));
  }
}

function* handleGetLotNumSuggestion(request: any) {
  try {
    const response: AxiosResponse = yield call(
      getLotNumSuggest,
      request.payload.query,
      request.payload.fields,
      request.payload.limit
    );

    if (response?.data?.Results) {
      yield put(getLotNumSuggestSuccess(response.data.Results));
    } else {
      yield put(getLotNumSuggestFailure('Unable to get address suggestion.'));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err)
      ? err.response?.data.message
      : undefined;
    put(getLotNumSuggestFailure(msg || 'Unable to get address suggestion.'));
  }
}

function* watchGetAddressSuggestionRequest() {
  yield takeLatest(
    MapActionTypes.GET_ADDRESS_SUGGESTION_START,
    handleGetAddressSuggestion
  );
}

function* watchGetAddressCandidate() {
  yield takeLatest(
    MapActionTypes.GET_ADDRESS_CANDIDATE_START,
    handleGetAddressCandidate
  );
}

function* watchGetLotNumSuggestionRequest() {
  yield takeLatest(
    MapActionTypes.GET_LOT_NUM_SUGGESTION_START,
    handleGetLotNumSuggestion
  );
}

function* sagas() {
  yield all([
    call(watchGetAddressSuggestionRequest),
    call(watchGetAddressCandidate),
    call(watchGetLotNumSuggestionRequest)
  ]);
}
export default sagas;
